import { css } from 'styled-components';

// Add external link icon in an ::after psuedo element
export const externalLinkIconAfter = css`
  &::after {
    content: '';
    display: inline-block;
    mask-image: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16" height="16"><path d="M16 0v15.1h-2.7V4.5L1.9 16 0 14.1 11.5 2.7H1V0h15z"/></svg>');
    mask-size: 100%;
    mask-position: top;
    mask-repeat: no-repeat;
    width: 0.4em;
    height: 0.8em;
    background-color: currentColor;
  }
`;
